import React, { Component } from 'react';
import WidgetTitle from './WidgetTitle';
import ResultMenuBar from './ResultMenuBar';
import './ResultWidget.css'
import ResultListBox from './ResultListBox';
import ResultAnalysisBox from './ResultAnalysisBox';
import CriteriaListWidget from './CriteriaListWidget';

export default class ResultWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            section: "list",
            recperpageList:50
        };
    }
    handleRecPerPageChange = (recperpage) => {
        this.props.onRecPerPageChange(recperpage,true);
    }
    handlePageChange = (pageno) => {
        this.props.onPageChange(pageno,true);
    }
    handleSort = (col) => {
        this.props.onSort(col);
    }
    handleMenuChange = (section) => {
        this.setState({ section });
        if(section!="list"){
            this.props.onRecPerPageChange(10,true); 
        }else{
            this.props.onRecPerPageChange(50,true); 
        }
    }
    handleDownloadCSV = () => {
        this.props.onDownloadCSV();
    }
    handleSaveScreener = () => {
        this.props.handlePopupChange("myscreener");
    }
    handleChange=(checked)=>{
        let presetselected=false;
        // if(this.props.savebtnStyleName==="screenersavedbtn"&&this.props.fromPreset){presetselected=true}
        this.props.handleChange(checked);
    }
    clearAll = ()=>{
        this.props.clearAll();
    }
    render() {
        return (
            <div className="ResultWidget">
                <div className="loading" style={{display: this.props.isLoading?"block":"none"}}><div className="loader"></div></div>
                
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                <WidgetTitle content="検索結果" />
                {/* <div className="screenersavebtn" onClick={this.handleSaveScreener}>Myスクリーナーに保存</div> */}
                <CriteriaListWidget handlePopupChange={this.props.handlePopupChange} showSearchResult={this.props.showSearchResult} handleChange={this.handleChange} uiHidden={this.props.uiHidden}  savebtnStyleName={this.props.savebtnStyleName} savebtnName={this.props.savebtnName}/>
              
                </div>
               
                <ResultMenuBar section={this.state.section} onMenuChange={this.handleMenuChange} onDownloadCSV={this.handleDownloadCSV} />
                { this.state.section==="list" &&
                <ResultListBox token={this.props.token} appId={this.props.appId} clearAll={this.clearAll} criteria={this.props.criteria} data={this.props.data} advancedQueue={this.props.advancedQueue} isLoading={this.props.isLoading} recperpage={this.props.recperpage} pageno={this.props.pageno} sortby={this.props.sortby} sortorder={this.props.sortorder} onRecPerPageChange={this.handleRecPerPageChange} onPageChange={this.handlePageChange} onSort={this.handleSort} />
                }
                { this.state.section==="analysis" &&
                <ResultAnalysisBox token={this.props.token} appId={this.props.appId} section={this.state.section} criteria={this.props.criteria} data={this.props.data} isLoading={this.props.isLoading} recperpage={this.props.recperpage} pageno={this.props.pageno} sortby={this.props.sortby} sortorder={this.props.sortorder} onRecPerPageChange={this.handleRecPerPageChange} onPageChange={this.handlePageChange} onSort={this.handleSort} handleCompInfoPopupChange={this.props.handleCompInfoPopupChange}/>
                } 

            </div>
        );
    }
}